module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( contribution_ranking ))==null?'':__t)+
'</td>\n<td>'+
((__t=( contributor_name ))==null?'':__t)+
'</td>\n<td>'+
((__t=( business_name ))==null?'':__t)+
'</td>\n<td>'+
((__t=( total_contribution_records ))==null?'':__t)+
'</td>\n<td>'+
((__t=( total_dollars ))==null?'':__t)+
'</td>\n<td>'+
((__t=( percent_of_total_dollars + '%' ))==null?'':__t)+
'</td>\n';
}
return __p;
};
